
































































































































import { getCategoryByType } from '@/api/category'
import {
  getSetmealPage,
  enableOrDisableSetmeal,
  deleteSetmeal,
} from '@/api/setMeal'
export default {
  data() {
    return {
      name: '',
      page: 1,
      pageSize: 10,
      total: 0,
      records: [],
      categoryId: '',
      status: '',
      categoryList: [],
      statusList: [
        {
          name: '启售',
          value: 1,
        },
        {
          name: '停售',
          value: 0,
        },
      ],
    }
  },
  created() {
    getCategoryByType({ type: 2 }).then((res) => {
      if (res.data.code === 1) {
        this.categoryList = res.data.data
      }
    }),
      this.pageQuery()
  },
  methods: {
    // 分页查询
    pageQuery() {
      // 封装查询参数
      const params = {
        page: this.page,
        pageSize: this.pageSize,
        name: this.name,
        categoryId: this.categoryId,
        status: this.status,
      }
      getSetmealPage(params).then((res) => {
        if (res.data.code === 1) {
          this.records = res.data.data.records
          this.total = res.data.data.total
        }
      })
    },
    //分页条的事件处理函数，pageSize 改变时会触发
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.pageQuery()
    },
    //分页条的事件处理函数，currentPage 改变时会触发
    handleCurrentChange(page) {
      this.page = page
      this.pageQuery()
    },
    //套装起售、停售
    handleStartOrStop(row) {
      this.$confirm('确认调整该套装的售卖状态?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        enableOrDisableSetmeal({ id: row.id, status: !row.status ? 1 : 0 })
          .then((res) => {
            if (res.status === 200) {
              this.$message.success('套装售卖状态更改成功！')
              this.pageQuery()
            }
          })
          .catch((err) => {
            this.$message.error('请求出错了：' + err.message)
          })
      })
    },
    //删除套装
    handleDelete(type: string, id: string) {
      if (type === 'B' && this.multipleSelection.length == 0) {
        this.$message('请选择需要删除的套装！')
        return
      }
      this.$confirm('确定删除该套装?', '确定删除', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let param = ''
        //判断当前是单个删除还是批量删除
        if (type === 'S') {
          //单个删除
          param = id
        } else {
          //批量删除
          const arr = new Array()
          this.multipleSelection.forEach((element) => {
            //将套装id放入数组中
            arr.push(element.id)
          })
          param = arr.join(',') //将数组中的id拼接到一起，中间用逗号分隔
        }
        deleteSetmeal(param).then((res) => {
          if (res.data.code === 1) {
            this.$message.success('删除成功！')
            this.pageQuery()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val) {
      this.multipleSelection = val
      //alert(this.multipleSelection.length)
    },
    //新增套装，跳转到新增页面（组件）
    handleAdd() {
      this.$router.push('/setmeal/add')
    },
    // 修改套装，跳转到修改页面（组件）
    handleEditSetmeal(row) {
      this.$router.push({
        path: '/setmeal/add',
        query: {
          id: row.id,
        },
      })
    },
  },
}
